// src/app/pages/donate/donate.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { MetaPixelService } from '../../services/meta-pixel.service';

@Component({
  selector: 'app-donate',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './donate.component.html',
  styleUrls: ['./donate.component.css']
})
export class DonateComponent implements OnInit {
  raised = 6000;
  goal = 250000;
  selectedAmount: number | null = null;

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly donatePageId =
    `${this.baseUrl}/donate#donate`;

  private readonly donateActionId =
    `${this.baseUrl}/donate#donation`;

  constructor(
    private seo: SeoService,
    private metaPixel: MetaPixelService
  ) {}

  ngOnInit(): void {
    this.seo.update(
      'Donate',
      'Support Lydia Christensen\'s Libertarian Michigan Senate campaign. No PACs, no corporate money — every dollar goes directly to winning Michigan.',
      'donate'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",

      "@graph": [
        {
          "@type": "WebPage",

          "@id": this.donatePageId,

          "url": `${this.baseUrl}/donate`,

          "name": "Donate to Lydia Christensen",

          "description":
            "Support Lydia Christensen's Libertarian Michigan Senate campaign. No PACs, no corporate money — every dollar goes directly to winning Michigan.",

          "isPartOf": {
            "@id": this.seo.websiteId
          },

          "about": {
            "@id": this.seo.lydiaId
          },

          "publisher": {
            "@id": this.seo.campaignId
          },

          "mainEntity": {
            "@id": this.donateActionId
          },

          "inLanguage": "en-US"
        },

        {
          "@type": "DonateAction",

          "@id": this.donateActionId,

          "name":
            "Donate to Lydia Christensen's U.S. Senate campaign",

          "description":
            "Make a donation to support Lydia Christensen's campaign for the United States Senate.",

          "recipient": {
            "@id": this.seo.campaignId
          },

          "object": {
            "@id": this.seo.campaignId
          },

          "target": {
            "@type": "EntryPoint",

            "urlTemplate":
              `${this.baseUrl}/donate`
          }
        }
      ]
    });

    this.metaPixel.trackDonatePageView();

    // Optionally fetch raised and goal from a service
    // Example: this.donationService.getProgress().subscribe(data => {
    //   this.raised = data.raised;
    //   this.goal = data.goal;
    // });
  }

  setDonation(amount: number): void {
    this.selectedAmount = amount;

    const iframe =
      document.querySelector(
        'iframe[name="donorbox"]'
      ) as HTMLIFrameElement;

    if (iframe) {
      iframe.src =
        `https://donorbox.org/embed/lydia-christensen-for-united-states-senate?amount=${amount}`;
    }
  }
}